import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone, faCommentDots } from '@fortawesome/free-solid-svg-icons';
import "./EnquiryForm.css"
import NavBar from '../NavBar/NavBar';
import RunningHeader from '../RunningHeader/RunningHeader';
import Footer from '../Footer/Footer';
const EnquiryForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Submitted:', formData);
        alert('Thank you! Your inquiry has been submitted.');
        setFormData({ name: '', email: '', phone: '', message: '' });
    };

    return (
        <div>
        <NavBar/>
        <RunningHeader/>
        <div className="advertisement-form">
            <div className="enquiry-form-container">
                <h1>Advertisement With Us</h1>
                <p>Fill in the details below to submit your advertisement inquiry.</p>
                <form className="enquiry-form" onSubmit={handleSubmit}>
                    <div className="input-group name-group">
                        <label htmlFor="name">
                            <FontAwesomeIcon icon={faUser} /> Full Name
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Enter your full name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="input-group email-group">
                        <label htmlFor="email">
                            <FontAwesomeIcon icon={faEnvelope} /> Email Address
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter your email address"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="input-group phone-group">
                        <label htmlFor="phone">
                            <FontAwesomeIcon icon={faPhone} /> Phone Number
                        </label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            placeholder="Enter your phone number"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="input-group message-group">
                        <label htmlFor="message">
                            <FontAwesomeIcon icon={faCommentDots} /> Advertisement Message
                        </label>
                        <textarea
                            id="message"
                            name="message"
                            placeholder="Enter your advertisement message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                    <button type="submit">Submit Enquiry</button>
                </form>
            </div>
        </div>
        <Footer/>
        </div>
    

    );
};

export default EnquiryForm;
